module.exports = __webpack_public_path__ + "static/media/bootstrap.ab904daa.jpg";